/**
 * Adres gotowej miniatury zapisanej obok oryginału (plik `<nazwa>_thumb.webp`).
 * Nie korzystamy już z przetwarzania „w locie" po stronie Storage — to naliczało
 * płatne transformacje przy każdym nowym zdjęciu.
 * Dla adresów spoza publicznego Storage (np. podpisane linki) zwracamy oryginał.
 */
const OBJECT_SEGMENT = "/storage/v1/object/public/";

/** Sufiks pliku miniatury. */
export const THUMB_SUFFIX = "_thumb";

/** Ścieżka miniatury dla ścieżki w buckecie, np. `user/kit/0.webp` → `user/kit/0_thumb.webp`. */
export function getThumbPath(path: string): string {
  return `${path.replace(/\.[^./]+$/, "")}${THUMB_SUFFIX}.webp`;
}

export function getThumbUrl(url: string | null | undefined, _size?: number): string {
  if (!url) return "";
  if (!url.includes(OBJECT_SEGMENT)) return url;

  try {
    const parsed = new URL(url);
    if (parsed.pathname.includes(`${THUMB_SUFFIX}.`)) return url;
    parsed.pathname = getThumbPath(parsed.pathname);
    return parsed.toString();
  } catch {
    return url;
  }
}

/**
 * Obsługa braku miniatury (stare zdjęcia): podmieniamy źródło na oryginał.
 * Użycie: `onError={handleThumbError(originalUrl)}`.
 */
export function handleThumbError(originalUrl: string | null | undefined) {
  return (event: React.SyntheticEvent<HTMLImageElement>) => {
    const img = event.currentTarget;
    if (!originalUrl || img.dataset.thumbFallback === "1") return;
    img.dataset.thumbFallback = "1";
    img.src = originalUrl;
  };
}
